import AdminLayout from "./AdminLayout";

const History = () => {
    return (
        <>
            <AdminLayout>
                <div className="history_action_wepper">
                    <div className="history_action_inner row">
                        <div className="col-lg-1">
                            {/* <label className="radio-button-container">
                                <input type="radio" name="radio" />
                                <span className="checkmark"></span>
                            </label> */}
                        </div>
                        <div className="col-lg-2">
                            <h3>Code</h3>
                        </div>
                        <div className="col-lg-2">
                            <h3>Name</h3>
                        </div>
                        <div className="col-lg-5">
                            <h3>Email</h3>
                        </div>
                        <div className="col-lg-2">
                            <h3>Actions</h3>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" checked />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="history_action_box">
                        <div className="history_action_inner row">
                            <div className="col-lg-1 ">
                                <label className="radio-button-container">
                                    <input type="radio" name="radio" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-2 Quote0_weeepr">
                                <h3>Quote01</h3>
                            </div>
                            <div className="col-lg-2">
                                <div className="user_name">
                                    <img src="images/admin-pic.png" alt="" />
                                    <span>Jack Adams</span>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <h3>Thank you for considering Sparks HVAC for your HVAC Repair Quotation....
                                </h3>
                            </div>
                            <div className="col-lg-2 ">
                                <div className="history_img">
                                    <img src="images/histry-icon.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </>
    )
}
export default History;